import { render } from "./xinghuo.vue?vue&type=template&id=571b3612"
const script = {}

import exportComponent from "C:\\Users\\A\\Desktop\\开发资料\\iPetroleum\\lingmou\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__